module.exports = __webpack_public_path__ + "static/pic02-6981854e539a41a2fd875461a62bfe5c.jpg";